import { Component, OnDestroy, OnInit } from "@angular/core";
import { MatSnackBar } from "@angular/material";
import { ActivatedRoute, Router } from "@angular/router";
import {
  ModalDismissReasons,
  NgbModal,
  NgbModalOptions,
  NgbModalRef,
} from "@ng-bootstrap/ng-bootstrap";
import { timeout } from "rxjs/operators";
import { HomeService } from "../home.service";

@Component({
  selector: "app-fill-form",
  templateUrl: "./fill-form.component.html",
  styleUrls: ["./fill-form.component.scss"],
})
export class FillFormComponent implements OnInit, OnDestroy {
  questionList = [];
  tagName = "";
  SectionList = [];
  forumData: any;
  totalQuestion: number = 0;
  totalFilled: number = 0;
  isSection: boolean = false;
  isLoading: boolean = false;
  isUploading: boolean = false;
  userId: any;
  formId: any;
  studyId:any;
  circleId: any;
  isFormEdited: any;
  interval: any;
  modelOptions: NgbModalOptions = {
    backdrop: "static",
    keyboard: false,
    size: "lg",
  };
  from = "";
  closeResult: string;
  private modalRef: NgbModalRef;

  constructor(
    private _snackBar: MatSnackBar,
    private router: Router,
    private route: ActivatedRoute,
    private homeService: HomeService,
    private modalService: NgbModal
  ) {}
  type = "";
  ngOnInit() {
    this.url = ""
    this.route.queryParams.subscribe((param) => {
      this.userId = param["userId"];
      this.formId = param["formId"];
      this.studyId = param["studyId"];
      this.circleId = param["circleId"];
      this.isFormEdited = param["isFormSubmittedByMe"];
      this.from = param["from"];
      this.type = param["type"];
      if (param) {
        if (this.type == "view_preview") {
          this.isEdit = true;
        } else {
          this.isEdit = false;
        }
        if (this.isFormEdited == "true") {
          this.getUserFormEditedDetail();
        } else {
          this.getFormDetail();
        }
      }
    });
  }

  getFormDetail() {
    this.isLoading = true;
    let query = "?formId=" + this.formId 
    if(this.studyId != undefined){
      query = query + "&studyId=" + this.studyId;
    }
    this.homeService.getFormDetailApi(query).subscribe(
      (res) => {
        this.isLoading = false;
        if ((res["message"] = "Success")) {
          this.forumData = res.data.formList[0];
          this.responseType = this.forumData.userResponseType;
          this.questionList = this.forumData["questions"];
          if (this.questionList["0"]["sectionName"]) {
            this.isSection = true;
            this.SectionList = this.questionList;
            this.getResponseSection();
            this.interval = setInterval(() => {
              this.validateSectionForum("");
            }, 1000);
          } else {
            this.isSection = false;
            this.getResponse();
            this.interval = setInterval(() => {
              this.validateForum("");
            }, 1000);
          }
        } else {
          this.isLoading = false;
        }
      },
      (err) => {
        this.isLoading = false;
      }
    );
  }

  responseType: any;
  getUserFormEditedDetail() {
    this.isLoading = true;
    let query = "?formId=" + this.formId + "&userId=" + this.userId;
    this.homeService.getUserFormEditedDetailApi(query).subscribe(
      (res) => {
        this.isLoading = false;
        if ((res["message"] = "Success")) {
          this.forumData = res.data.formResponseList[0];
          this.questionList = this.forumData["formData"]["questions"];
          this.userReponse = this.forumData["questions"];

          if (this.questionList["0"]["sectionName"]) {
            this.isSection = true;
            this.SectionList = this.questionList;
            this.updateUserResponseSection();
            this.interval = setInterval(() => {
              this.validateSectionForum("");
            }, 1000);
          } else {
            this.isSection = false;
            this.updateUserResponse();
            this.interval = setInterval(() => {
              this.validateForum("");
            }, 1000);
          }
        } else {
          this.isLoading = false;
        }
      },
      (err) => {
        this.isLoading = false;
      }
    );
  }
  ngOnDestroy() {
    localStorage.removeItem("question");
    if(this.interval){
      clearInterval(this.interval)
    }
  }
  validateForum(event: any) {
    this.totalFilled = 0;
    this.totalQuestion = 0;
    for (let i = 0; i < this.questionList.length; i++) {
      if (
        this.questionList[i]["isRequired"] == true &&
        this.questionList[i]["type"] == "checkbox"
      ) {
        let count = 0;
        this.questionList[i]["values"].forEach((element) => {
          if (element["valueSelect"] == true) {
            if (count <= 0) {
              this.totalFilled = this.totalFilled + 1;
              count = count + 1;
            }
          }
        });
      }
      if (
        this.questionList[i]["isRequired"] == true &&
        this.questionList[i]["type"] == "text"
      ) {
        if (this.questionList[i]["valuesText"] !== "") {
          this.totalFilled = this.totalFilled + 1;
        }
      }
      if (
        this.questionList[i]["isRequired"] == true &&
        this.questionList[i]["type"] == "radio"
      ) {
        if (this.questionList[i]["valuesText"] !== "") {
          this.totalFilled = this.totalFilled + 1;
        }
      }
      if (
        this.questionList[i]["isRequired"] == true &&
        this.questionList[i]["type"] == "number"
      ) {
        if (this.questionList[i]["valuesText"] !== "") {
          this.totalFilled = this.totalFilled + 1;
        }
      }
      if (
        this.questionList[i]["isRequired"] == true &&
        this.questionList[i]["type"] == "date"
      ) {
        if (this.questionList[i]["valuesText"] !== "") {
          this.totalFilled = this.totalFilled + 1;
        }
      }
      if (
        this.questionList[i]["isRequired"] == true &&
        this.questionList[i]["type"] == "singleSelect"
      ) {
        if (this.questionList[i]["valuesText"] !== "") {
          this.totalFilled = this.totalFilled + 1;
        }
      }
      if (
        this.questionList[i]["isRequired"] == true &&
        this.questionList[i]["type"] == "upload"
      ) {
        if (this.questionList[i]["valuesText"] !== "") {
          this.totalFilled = this.totalFilled + 1;
        }
      }
      if (
        this.questionList[i]["isRequired"] == true &&
        this.questionList[i]["type"] == "multiUpload"
      ) {
        if (this.questionList[i]["valuesText"] !== "") {
          this.totalFilled = this.totalFilled + 1;
        }
      }

      if (this.questionList[i]["isRequired"] == true) {
        this.totalQuestion = this.totalQuestion + 1;
      }
    }
  }

  // VALIDATE FOR SECTION REQUIRED FIEDS
  showExtraComment:boolean = false
  validateSectionForum(event: any) {
    this.showExtraComment= false;
    this.totalFilled = 0;
    this.totalQuestion = 0;
    for (let j = 0; j < this.SectionList.length; j++) {      
      for (let i = 0; i < this.SectionList[j]["questions"].length; i++) {
        if (
          this.SectionList[j]["questions"][i]["isRequired"] == true &&
          this.SectionList[j]["questions"][i]["type"] == "checkbox"
        ) {
          let count = 0;
          this.SectionList[j]["questions"][i]["values"].forEach((element) => {
            if (element["valueSelect"] == true) {
              if (count <= 0) {
                this.totalFilled = this.totalFilled + 1;
                count = count + 1;
              }
            }
          }); 
        }
        if (
          this.SectionList[j]["questions"][i]["isRequired"] == true &&
          this.SectionList[j]["questions"][i]["type"] == "text"
        ) {
          if (this.SectionList[j]["questions"][i]["valuesText"] !== "") {
            this.totalFilled = this.totalFilled + 1;
          }
        }
        if (
          this.SectionList[j]["questions"][i]["isRequired"] == true &&
          this.SectionList[j]["questions"][i]["type"] == "radio"
        ) {
          if (this.SectionList[j]["questions"][i]["valuesText"] !== "") {
            this.totalFilled = this.totalFilled + 1;     
          }
        }
        if (
          this.SectionList[j]["questions"][i]["type"] == "radio" && 
          this.SectionList[j]["questions"][i]["valuesText"] == 'Revise Calendar(s)'
        ) {
          
          this.showExtraComment = true
    
        }
        if (
          this.SectionList[j]["questions"][i]["isRequired"] == true &&
          this.SectionList[j]["questions"][i]["type"] == "singleSelect"
        ) {
          if (this.SectionList[j]["questions"][i]["valuesText"] !== "") {
            this.totalFilled = this.totalFilled + 1;
          }
        }
        if (
          this.SectionList[j]["questions"][i]["isRequired"] == true &&
          this.SectionList[j]["questions"][i]["type"] == "number"
        ) {
          if (this.SectionList[j]["questions"][i]["valuesText"] !== "") {
            this.totalFilled = this.totalFilled + 1;
          }
        }
        if (
          this.SectionList[j]["questions"][i]["isRequired"] == true &&
          this.SectionList[j]["questions"][i]["type"] == "date"
        ) {
          if (this.SectionList[j]["questions"][i]["valuesText"] !== "") {
            this.totalFilled = this.totalFilled + 1;
          }
        }
        if(this.SectionList[j]['questions'][i]['isRequired'] == true && this.SectionList[j]['questions'][i]['type'] == 'upload'){
          if(this.SectionList[j]['questions'][i]['valuesText'] !== ''){
            this.totalFilled = this.totalFilled +1
          }
        }
        

        if (this.SectionList[j]["questions"][i]["isRequired"] == true) {
          this.totalQuestion = this.totalQuestion + 1;
          // if(this.SectionList[j]["questions"][i]['values'].length > 0) {
          //   this.SectionList[j]["questions"][i]['values'].forEach(element => {
          //     element['questions'].forEach(element1 => {
          //       if(element1['isRequired'] == true) {
          //         this.totalQuestion = this.totalQuestion + 1;
          //       }
          //     });
          //   });
          // }
        }
      }
    }
  }

  submitForm() {
    if (this.isSection == true) {
      this.getResponseSection();
    } else {
      this.getResponse();
    }
    if (this.isFormEdited == "false") {
      if (this.totalQuestion !== this.totalFilled) {
        return this._snackBar.open("Please fill all mandatory fields", "", {
          duration: 3000,
          horizontalPosition: "right",
          verticalPosition: "top",
          panelClass: ["success"],
        });
      } else {
        let req = {};
        if (this.isSection == false) {
          req["response"] = this.questionList;
          req["questions"] = this.finalResponse;
        } else {
          req["response"] = this.SectionList;
          req["questions"] = this.finalResponse;
        }
        req["formId"] = this.formId;
        
        if(this.studyId && this.studyId !== '') {
          req['studyId']= this.studyId;
        }
        this.isLoading = true;
        this.homeService.submitMultipleTypeForm(req).subscribe(
          (res) => {
            this.isLoading = false;
            if ((res["message"] == "Success")) {
              if (this.from == "multi") {
                this.router.navigate(["/main/multiple-form-list"], {
                  queryParams: {
                    userId: this.userId,
                    formId: this.formId,
                    circleId: this.circleId,
                    isFormSubmittedByMe: this.isFormEdited,
                  },
                  preserveQueryParams: false,
                });
              } 
              else if(this.studyId && this.studyId !== '') {
                this.router.navigate(["/main/tuft-dashboard"], {
                  preserveQueryParams: false,
                });
              }  
              else {
                this.router.navigate(
                  ["/main/circles/circle-profile/circle-members"],
                  {
                    queryParams: { ownerId: this.userId, id: this.circleId },
                    preserveQueryParams: false,
                  }
                );
              }
              return this._snackBar.open("Form submitted successfully !", "", {
                duration: 3000,
                horizontalPosition: "right",
                verticalPosition: "top",
                panelClass: ["success"],
              });
            } else {
              this.isLoading = false;
            }
          },
          (err) => {
            this.isLoading = false;
          }
        );
      }
    }
  }
  isFormValidate: boolean = false;
  validateForm() {
    if (this.totalQuestion !== this.totalFilled) {
      this.isFormValidate = false;
    } else {
      this.isFormValidate = true;
    }
  }

  formEditSumbit() {
    if (this.isSection == true) {
      this.getResponseSection();
    } else {
      this.getResponse();
    }
    if (this.isFormEdited == "true") {
      if (this.totalQuestion !== this.totalFilled) {
        return this._snackBar.open("Please fill all mandatory fields", "", {
          duration: 3000,
          horizontalPosition: "right",
          verticalPosition: "top",
          panelClass: ["success"],
        });
      } else {
        let req = {};
        if (this.isSection == false) {
          req["response"] = this.questionList;

          req["questions"] = this.finalResponse;
        } else {
          req["response"] = this.SectionList;
          req["questions"] = this.finalResponse;
        }
        req["formResponseId"] = this.forumData.formResponseId;
        this.isLoading = true;
        this.homeService.submitSingleTypeForm(req).subscribe(
          (res) => {
            this.isLoading = false;
            if ((res["message"] = "Success")) {
              this.router.navigate(
                ["/main/circles/circle-profile/circle-members"],
                {
                  queryParams: { ownerId: this.userId, id: this.circleId },
                  preserveQueryParams: false,
                }
              );
              return this._snackBar.open("Form submitted successfully !", "", {
                duration: 3000,
                horizontalPosition: "right",
                verticalPosition: "top",
                panelClass: ["success"],
              });
            } else {
              this.isLoading = false;
            }
          },
          (err) => {
            this.isLoading = false;
          }
        );
      }
    }
  }

  openAddTagModal(content, btn) {
    this.modelOptions = {
      backdrop: "static",
      keyboard: false,
      size: "md",
    };

    btn &&
      btn.parentElement &&
      btn.parentElement.parentElement &&
      btn.parentElement.parentElement.blur();
    this.modalRef = this.modalService.open(content, this.modelOptions);
    this.modalRef.result.then(
      (result) => {
        this.closeResult = `Closed with: ${result}`;
      },
      (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }

  navigateBAck() {
    if (this.from == "admin") {
      this.router.navigate(["/main/setting/manage-forum/viewForum"], {
        queryParams: { ownerId: this.userId, id: this.circleId },
        preserveQueryParams: false,
      });
    } else if (this.studyId && this.studyId !== '') {
      this.router.navigate(["/main/tuft-dashboard"])
    } else {
      this.router.navigate(["/main/circles/circle-profile/circle-members"], {
        queryParams: { ownerId: this.userId, id: this.circleId },
        preserveQueryParams: false,
      });
    }
  }
  isEdit: boolean = false;
  navigateEdit() {
    this.isEdit = !this.isEdit;
  }

  url = "";
  selectedFile: File;
  uploadAttachment(event, index) {
    this.url = ""
    this.selectedFile = null;
    this.isLoading = true;
    this.selectedFile = event.target.files[0];

    this.homeService.uploadImage(this.selectedFile).subscribe(
      (res) => {
        this.isLoading = false;
        if (res["message"] == "Success") {
          this.isUploading = true;
          this.url = res["data"].url;
          this.questionList[index]["valuesText"] = res.data.url;
          setTimeout(() => {
            /** spinner ends after 1 seconds */
            this.isUploading = false;
          }, 1000);
        } else {
        }
      },
      (err) => {
        this.isLoading = false;
      }
    );
  }

  uploadAttachmentSection(type,event, Sectionindex, QuestionIndex) {
    this.selectedFile = null;
    this.isLoading = true;
    this.selectedFile = event.target.files[0];
    let regex = new RegExp('[^.]+$');
    let extension = this.selectedFile.name.match(regex);
    this.homeService.uploadImage(this.selectedFile).subscribe(
      (res) => {
        this.isLoading = false;
        if (res["message"] == "Success") {
          this.isUploading = true;
          this.url = res["data"].url;
          if(type == 'upload') {
            this.SectionList[Sectionindex]["questions"][QuestionIndex].values = [];
            this.SectionList[Sectionindex]["questions"][QuestionIndex].values.push({url:this.url,fileName:this.selectedFile['name'],fileType:extension});
          } else {
            this.SectionList[Sectionindex]["questions"][QuestionIndex].values.push({url:this.url,fileName:this.selectedFile['name'],fileType:extension});
          }
          
          setTimeout(() => {
            /** spinner ends after 1 seconds */
            this.isUploading = false;
          }, 1000);
        } else {
        }
      },
      (err) => {
        this.isLoading = false;
      }
    );
  }

  uploadAttachment1(type,event, Sectionindex, QuestionIndex, followIndex,ff) {
    this.selectedFile = null;
    this.isLoading = true;
    this.selectedFile = event.target.files[0];
   let regex = new RegExp('[^.]+$');
   let extension = this.selectedFile.name.match(regex);
    this.homeService.uploadImage(this.selectedFile).subscribe(
      (res) => {
        this.isLoading = false;
        if (res["message"] == "Success") {
          this.isUploading = true;
          this.url = res["data"].url;
          if(type == 'upload') {
            this.SectionList[Sectionindex]["questions"][QuestionIndex]["values"][followIndex]["questions"][ff].values = []
            this.SectionList[Sectionindex]["questions"][QuestionIndex]["values"][followIndex]["questions"][ff].values.push({url:this.url,fileName:this.selectedFile['name'],fileType:extension});
          } else {
            this.SectionList[Sectionindex]["questions"][QuestionIndex]["values"][followIndex]["questions"][ff].values.push({url:this.url,fileName:this.selectedFile['name'],fileType:extension});
          }
          

          setTimeout(() => {
            /** spinner ends after 1 seconds */
            this.isUploading = false;
          }, 1000);
        } else {
        }
      },
      (err) => {
        this.isLoading = false;
      }
    );
  }

  removeImage (Sectionindex,QuestionIndex,ImageIndex) {
    this.SectionList[Sectionindex]["questions"][QuestionIndex].values.splice(ImageIndex,1);
  }
  removeImage1 (Sectionindex,QuestionIndex,followIndex,question,ImageIndex) {
    this.SectionList[Sectionindex]["questions"][QuestionIndex]["values"][followIndex]["questions"][question].values.splice(ImageIndex,1);
  }

  openwebView(value) {
    let index = value.indexOf("http");
    let url = "";
    if (index == -1) {
      url = "http://" + value;
    } else {
      url = value;
    }
    window.open(url, "_blank");
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return "by pressing ESC";
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return "by clicking on a backdrop";
    } else {
      return `with: ${reason}`;
    }
  }

  finalResponse = [];
  getResponse() {
    this.finalResponse = [];
    for (let i = 0; i < this.questionList.length; i++) {
      if (
        this.questionList[i]["type"] == "upload" ||
        this.questionList[i]["type"] == "multiUpload" ||
        this.questionList[i]["type"] == "date" ||
        this.questionList[i]["type"] == "number" ||
        this.questionList[i]["type"] == "text" ||
        this.questionList[i]["type"] == "text"
      ) {
        this.finalResponse.push({
          questionId: this.questionList[i]["questionId"],
          answer: this.questionList[i]["valuesText"],
          headerName: this.questionList[i]["questionHeader"],
        });
      }

      if (this.questionList[i]["type"] == "checkbox") {
        let tempVal = [];
        this.questionList[i]["values"].forEach((element1) => {
          if (element1["valueSelect"] == true) {
            tempVal.push(element1["label"]);
          }
        });
        this.questionList[i]["valuesText"] = tempVal.toString();
        this.finalResponse.push({
          questionId: this.questionList[i]["questionId"],
          answer: this.questionList[i]["valuesText"],
          headerName: this.questionList[i]["questionHeader"],
        });
      }

      if (this.questionList[i]["type"] == "radio") {
        this.finalResponse.push({
          questionId: this.questionList[i]["questionId"],
          answer: this.questionList[i]["valuesText"],
          headerName: this.questionList[i]["questionHeader"],
        });
        this.questionList[i]["values"].forEach((element) => {
          if (element["isLevel"] == true) {
            for (let j = 0; j < element["questions"].length; j++) {
              this.finalResponse.push({
                questionId: element["questions"][j]["questionId"],
                answer: element["questions"][j]["valuesText"],
                headerName: element["questions"][j]["questionHeader"],
              });
            }
          }
        });
      }
      if (this.questionList[i]["type"] == "singleSelect") {
        this.finalResponse.push({
          questionId: this.questionList[i]["questionId"],
          answer: this.questionList[i]["valuesText"],
          headerName: this.questionList[i]["questionHeader"],
        });
        this.questionList[i]["values"].forEach((element) => {
          if (element["isLevel"] == true) {
            for (let j = 0; j < element["questions"].length; j++) {
              this.finalResponse.push({
                questionId: element["questions"][j]["questionId"],
                answer: element["questions"][j]["valuesText"],
                headerName: element["questions"][j]["questionHeader"],
              });
            }
          }
        });
      }
    }
  }

  getResponseSection() {
    this.finalResponse = [];
    for (let k = 0; k < this.SectionList.length; k++) {
      for (let i = 0; i < this.SectionList[k]["questions"].length; i++) {
        if (
          this.SectionList[k]["questions"][i]["type"] == "upload" ||
          this.SectionList[k]["questions"][i]["type"] == "multiUpload" ||
          this.SectionList[k]["questions"][i]["type"] == "date" ||
          this.SectionList[k]["questions"][i]["type"] == "number" ||
          this.SectionList[k]["questions"][i]["type"] == "text" ||
          this.SectionList[k]["questions"][i]["type"] == "text"
        ) {
          this.finalResponse.push({
            questionId: this.SectionList[k]["questions"][i]["questionId"],
            answer: this.SectionList[k]["questions"][i]["valuesText"],
            headerName: this.SectionList[k]["questions"][i]["questionHeader"],
          });
        }

        if (this.SectionList[k]["questions"][i]["type"] == "checkbox") {
          let tempVal = [];
          this.SectionList[k]["questions"][i]["values"].forEach((element1) => {
            if (element1["valueSelect"] == true) {
              tempVal.push(element1["label"]);
            }
          });
          this.SectionList[k]["questions"][i][
            "valuesText"
          ] = tempVal.toString();
          this.finalResponse.push({
            questionId: this.SectionList[k]["questions"][i]["questionId"],
            answer: this.SectionList[k]["questions"][i]["valuesText"],
            headerName: this.SectionList[k]["questions"][i]["questionHeader"],
          });
        }

        if (this.SectionList[k]["questions"][i]["type"] == "radio") {
          
          let checkVal = [];
          this.SectionList[k]["questions"][i]["values"].forEach((element1) => {
            element1['questions'].forEach((e)=>{
              e['values'].forEach(e2 => {
                if (e2["valueSelect"] == true) {

                  checkVal.push(e2["label"]);
                }
                e['valuesText'] = checkVal.toString();
              });
            
            })
          });
          
          this.finalResponse.push({
            questionId: this.SectionList[k]["questions"][i]["questionId"],
            answer: this.SectionList[k]["questions"][i]["valuesText"],
            headerName: this.SectionList[k]["questions"][i]["questionHeader"],
          });
          this.SectionList[k]["questions"][i]["values"].forEach((element) => {
            if (element["isLevel"] == true) {
              for (let j = 0; j < element["questions"].length; j++) {
                this.finalResponse.push({
                  questionId: element["questions"][j]["questionId"],
                  answer: element["questions"][j]["valuesText"],
                  headerName: element["questions"][j]["questionHeader"],
                });
              }
            }
          });
        }
        if (this.SectionList[k]["questions"][i]["type"] == "singleSelect") {
          this.finalResponse.push({
            questionId: this.SectionList[k]["questions"][i]["questionId"],
            answer: this.SectionList[k]["questions"][i]["valuesText"],
            headerName: this.SectionList[k]["questions"][i]["questionHeader"],
          });
          this.SectionList[k]["questions"][i]["values"].forEach((element) => {
            if (element["isLevel"] == true) {
              for (let j = 0; j < element["questions"].length; j++) {
                this.finalResponse.push({
                  questionId: element["questions"][j]["questionId"],
                  answer: element["questions"][j]["valuesText"],
                  headerName: element["questions"][j]["questionHeader"],
                });
              }
            }
          });
        }
      }
    }
  }

  userReponse = [];
  updateUserResponseSection() {
    for (let k = 0; k < this.SectionList.length; k++) {
      for (let i = 0; i < this.SectionList[k]["questions"].length; i++) {
        if (
          this.SectionList[k]["questions"][i]["type"] == "upload" ||
          this.SectionList[k]["questions"][i]["type"] == "multiUpload" ||
          this.SectionList[k]["questions"][i]["type"] == "date" ||
          this.SectionList[k]["questions"][i]["type"] == "number" ||
          this.SectionList[k]["questions"][i]["type"] == "text"
        ) {
          this.userReponse.forEach((element) => {
            if (
              this.SectionList[k]["questions"][i]["questionId"] ==
              element["questionId"]
            ) {
              this.SectionList[k]["questions"][i]["valuesText"] =
                element["answer"];
            }
          });
        }

        if (this.SectionList[k]["questions"][i]["type"] == "checkbox") {
          let valueText = [];
          this.userReponse.forEach((element) => {
            if (
              this.SectionList[k]["questions"][i]["questionId"] ==
              element["questionId"]
            ) {
              valueText = element["answer"].split(",");
              valueText.forEach((element) => {
                for (
                  let j = 0;
                  j < this.SectionList[k]["questions"][i]["values"].length;
                  j++
                ) {
                  if (
                    this.SectionList[k]["questions"][i]["values"][j]["label"] ==
                    element
                  ) {
                    this.SectionList[k]["questions"][i]["values"][j][
                      "valueSelect"
                    ] = true;
                  }
                }
              });
            }
          });
        }

        if (this.SectionList[k]["questions"][i]["type"] == "radio") {
          for (let p = 0; p < this.userReponse.length; p++) {
            if (
              this.SectionList[k]["questions"][i]["questionId"] ==
              this.userReponse[p]["questionId"]
            ) {
              this.SectionList[k]["questions"][i][
                "valuesText"
              ] = this.userReponse[p]["answer"];
            }
          }

          this.SectionList[k]["questions"][i]["values"].forEach((element) => {
            if (element["isLevel"] == true) {
              for (let j = 0; j < element["questions"].length; j++) {
                for (let m = 0; m < this.userReponse.length; m++) {
                  if (
                    element["questions"][j]["questionId"] ==
                    this.userReponse[m]["questionId"]
                  ) {
                    element["questions"][j]["valuesText"] = this.userReponse[m][
                      "answer"
                    ];
                  }
                }
              }
            }
          });
        }

        if (this.SectionList[k]["questions"][i]["type"] == "singleSelect") {
          for (let p = 0; p < this.userReponse.length; p++) {
            if (
              this.SectionList[k]["questions"][i]["questionId"] ==
              this.userReponse[p]["questionId"]
            ) {
              this.SectionList[k]["questions"][i][
                "valuesText"
              ] = this.userReponse[p]["answer"];
            }
          }

          this.SectionList[k]["questions"][i]["values"].forEach((element) => {
            if (element["isLevel"] == true) {
              for (let j = 0; j < element["questions"].length; j++) {
                for (let m = 0; m < this.userReponse.length; m++) {
                  if (
                    element["questions"][j]["questionId"] ==
                    this.userReponse[m]["questionId"]
                  ) {
                    element["questions"][j]["valuesText"] = this.userReponse[m][
                      "answer"
                    ];
                  }
                }
              }
            }
          });
        }
      }
    }
  }
  updateUserResponse() {
    for (let i = 0; i < this.questionList.length; i++) {
      if (
        this.questionList[i]["type"] == "upload" ||
        this.questionList[i]["type"] == "multiUpload" ||
        this.questionList[i]["type"] == "date" ||
        this.questionList[i]["type"] == "number" ||
        this.questionList[i]["type"] == "text"
      ) {
        this.userReponse.forEach((element) => {
          if (this.questionList[i]["questionId"] == element["questionId"]) {
            this.questionList[i]["valuesText"] = element["answer"];
          }
        });
      }

      if (this.questionList[i]["type"] == "checkbox") {
        let valueText = [];
        this.userReponse.forEach((element) => {
          if (this.questionList[i]["questionId"] == element["questionId"]) {
            valueText = element["answer"].split(",");

            valueText.forEach((element) => {
              for (let j = 0; j < this.questionList[i]["values"].length; j++) {
                if (this.questionList[i]["values"][j]["label"] == element) {
                  this.questionList[i]["values"][j]["valueSelect"] = true;
                }
              }
            });
          }
        });
      }

      if (this.questionList[i]["type"] == "radio") {
        for (let p = 0; p < this.userReponse.length; p++) {
          if (
            this.questionList[i]["questionId"] ==
            this.userReponse[p]["questionId"]
          ) {
            this.questionList[i]["valuesText"] = this.userReponse[p]["answer"];
          }
        }

        this.questionList[i]["values"].forEach((element) => {
          if (element["isLevel"] == true) {
            for (let j = 0; j < element["questions"].length; j++) {
              for (let m = 0; m < this.userReponse.length; m++) {
                if (
                  element["questions"][j]["questionId"] ==
                  this.userReponse[m]["questionId"]
                ) {
                  element["questions"][j]["valuesText"] = this.userReponse[m][
                    "answer"
                  ];
                }
              }
            }
          }
        });
      }

      if (this.questionList[i]["type"] == "singleSelect") {
        for (let p = 0; p < this.userReponse.length; p++) {
          if (
            this.questionList[i]["questionId"] ==
            this.userReponse[p]["questionId"]
          ) {
            this.questionList[i]["questions"][i][
              "valuesText"
            ] = this.userReponse[p]["answer"];
          }
        }

        this.questionList[i]["values"].forEach((element) => {
          if (element["isLevel"] == true) {
            for (let j = 0; j < element["questions"].length; j++) {
              for (let m = 0; m < this.userReponse.length; m++) {
                if (
                  element["questions"][j]["questionId"] ==
                  this.userReponse[m]["questionId"]
                ) {
                  element["questions"][j]["valuesText"] = this.userReponse[m][
                    "answer"
                  ];
                }
              }
            }
          }
        });
      }
    }
  }
}
